<section class="page-heading">
  <div><span class="eyebrow">Organization roles</span><h1>Private benchmarks</h1><p>Open a role to compare your talent pool against its aptitude and behavioral signals.</p></div>
  <button *ngIf="isAdmin" class="add-benchmark" type="button" (click)="createPrivateBenchmark()">
    <mat-icon>add</mat-icon><span>Add private benchmark</span>
  </button>
  <div *ngIf="!isAdmin" class="readonly-note"><mat-icon>lock</mat-icon><span>Benchmarks are managed by Konvac</span></div>
</section>

<div class="toolbar">
  <div class="search-field"><mat-icon>search</mat-icon><input [(ngModel)]="search" (ngModelChange)="applySearch()" placeholder="Search role or department" aria-label="Search benchmarks"></div>
  <span>{{ filteredBenchmarks.length }} roles</span>
</div>

<div class="loading" *ngIf="loading"><mat-spinner diameter="34"></mat-spinner><span>Loading role benchmarks…</span></div>
<div class="error" *ngIf="!loading && errorMessage"><mat-icon>error_outline</mat-icon><span>{{ errorMessage }}</span><button (click)="loadBenchmarks()">Try again</button></div>

<section class="benchmark-list" *ngIf="!loading && !errorMessage">
  <a class="benchmark-card" *ngFor="let benchmark of filteredBenchmarks" [routerLink]="['/recruitment/benchmarks', benchmark.benchmarkId]" queryParamsHandling="preserve">
    <div class="role-icon"><mat-icon>work_outline</mat-icon></div>
    <div class="card-content">
      <div class="card-topline"><span>{{ benchmark.department }}</span><span class="status" [class.refreshing]="benchmark.status === 'RECALCULATING'">{{ benchmark.status === 'READY' ? 'Ready' : 'Recalculating' }}</span></div>
      <h2>{{ benchmark.roleTitle }}</h2>
      <p>{{ benchmark.description }}</p>
      <div class="traits"><span *ngFor="let trait of benchmark.topTraits">{{ trait }}</span></div>
      <div class="progress-row">
        <div class="progress-track"><span [style.width.%]="progress(benchmark)"></span></div>
        <span>{{ benchmark.evaluatedCount }} of {{ benchmark.candidateCount }} evaluated</span>
      </div>
    </div>
    <div class="card-meta">
      <span>Version {{ benchmark.version }}</span>
      <span>Updated {{ benchmark.updatedAt | date:'MMM d' }}</span>
      <button *ngIf="isAdmin" class="edit-benchmark" type="button" (click)="editPrivateBenchmark(benchmark, $event)"><mat-icon>edit</mat-icon><span>Edit</span></button>
      <mat-icon *ngIf="!isAdmin">arrow_forward</mat-icon>
    </div>
  </a>
  <div class="empty" *ngIf="filteredBenchmarks.length === 0"><mat-icon>search_off</mat-icon><h2>No private benchmarks yet</h2><p>{{ isAdmin ? 'Add one from a public benchmark or create a new role.' : 'No benchmarks have been configured.' }}</p></div>
</section>
